import script from "./GeneralSettings.vue?vue&type=script&lang=ts&setup=true"
export * from "./GeneralSettings.vue?vue&type=script&lang=ts&setup=true"

import "./GeneralSettings.vue?vue&type=style&index=0&id=3805ee2a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3805ee2a"]])

export default __exports__